export const APP_CONTENT_ID = 'aws-howser-content';
